<template>
  <li
    v-if="canViewVerticalNavMenuGroup(item)"
    class="nav-item has-sub"
    :class="{
      open: isOpen,
      disabled: item.disabled,
      'sidebar-group-active': isActive,
    }"
  >
    <!-- @click="() => updateGroupOpen(!isOpen)" -->
    <b-link
      class="d-flex align-items-center setHover mr-0"
      @mouseenter="prefetchOnHover"
      @focus="prefetchOnHover"
      @click="openNew(item)"
      :to="sidebarGroupLink(item)"
      :data-nav-label="t(item.name)"
    >
      <feather-icon
        :icon="item.icon || 'CircleIcon'"
        :badge="hasAppsChat(item) ? $store.state.unreadCount : null"
        :badge-classes="['bg-danger', 'adjust-badge-position']"
      />
      <span class="menu-title text-truncate">{{ t(item.name) }}</span>
      <b-badge
        v-if="item.tag"
        pill
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto"
      >
        {{ item.tag }}
      </b-badge>
    </b-link>
    <!-- <b-collapse
      v-model="isOpen"
      class="menu-content"
      tag="ul"
    >
      <component
        :is="resolveNavItemComponent(child)"
        v-for="child in item.children"
        :key="child.header || child.title"
        ref="groupChild"
        :item="child"
      />
    </b-collapse> -->
  </li>
</template>

<script>
import { BLink, BBadge, BCollapse } from "bootstrap-vue";
import {
  resolveVerticalNavMenuItemComponent as resolveNavItemComponent,
  isNavGroupActive,
} from "@core/layouts/utils";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import { useUtils as useAclUtils } from "@core/libs/acl";
import { prefetchRoute } from "@/utils/routePrefetch";
import VerticalNavMenuHeader from "../vertical-nav-menu-header";
import VerticalNavMenuLink from "../vertical-nav-menu-link/VerticalNavMenuLink.vue";

// Composition Function
import useVerticalNavMenuGroup from "./useVerticalNavMenuGroup";
import mixinVerticalNavMenuGroup from "./mixinVerticalNavMenuGroup";

export default {
  name: "VerticalNavMenuGroup",
  components: {
    VerticalNavMenuHeader,
    VerticalNavMenuLink,
    BLink,
    BBadge,
    BCollapse,
  },
  mixins: [mixinVerticalNavMenuGroup],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { isOpen, isActive, updateGroupOpen, updateIsActive } =
      useVerticalNavMenuGroup(props.item);

    const { t } = useI18nUtils();
    const { canViewVerticalNavMenuGroup } = useAclUtils();

    return {
      resolveNavItemComponent,
      isOpen,
      isActive,
      updateGroupOpen,
      updateIsActive,

      // ACL
      canViewVerticalNavMenuGroup,

      // i18n
      t,
    };
  },
  methods: {
    prefetchOnHover() {
      const children = (this.item && this.item.children) || [];
      const firstRoute = children[0] && children[0].route;
      prefetchRoute(this.$router, firstRoute || this.item.route);
    },
    hasAppsChat(item) {
      if (!item || !Array.isArray(item.children)) return false;
      return item.children.some((child) => child && child.route === "apps-chat");
    },
    sidebarGroupLink(item) {
      const children = item?.children || [];
      if (isNavGroupActive(children)) {
        return this.$route;
      }
      const firstRoute = children[0]?.route;
      return firstRoute ? { name: firstRoute } : this.$route;
    },
    openNew(item) {
      // console.log(item);
      this.$store.commit("setCurrentMenu", item);
    },
  },
};
</script>

<style scoped>
.main-menu.menu-light .navigation > li.sidebar-group-active > a {
  /* background-color: #8074e5; */
  background-image: linear-gradient(47deg, var(--primary), #a79fed);
  color: white;

  border-right: 5px solid var(--dark);
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.setHover:hover {
  background: whitesmoke;
  border-right: 5px solid var(--secondary);
}
.adjust-badge-position {
  top: -7px;
  right: -3px;
}
</style>
